$(() => {
  const session_type = $('#session-type').val();

  if (session_type === 'self_service') {
    $('.avoid-payroll-penalty').slideUp(0);
  }
});
